import { HeroSlideshow } from "./HeroSlideshow";

export const HeroSection = () => {
  return <HeroSlideshow />;
};